export default __webpack_public_path__ + "static/media/dashboardlogo.01c090e5.png";